module.exports = __webpack_public_path__ + "static/media/american_express_large.689adefb.svg";